export default __webpack_public_path__ + "static/media/bg1.efba1763.jpeg";